<template>
  <div class="page-container">
    <el-card class="page-content" shadow="never">
      <el-breadcrumb separator="/" class="page-breadcrumb">
        <!-- <el-breadcrumb-item>
          <router-link to="/home/funds">资金概览</router-link>
        </el-breadcrumb-item> -->
        <el-breadcrumb-item>
          <div class="breadcrumb">
            <div class="left"></div>
            <div class="right">
              <h2>资金概览明细</h2>
            </div>
          </div>
        </el-breadcrumb-item>
      </el-breadcrumb>
      <div class="page-actions">
        <div class="select">
          <div class="item">
            <div class="ipt">
              <el-input v-model="channelUserId" placeholder="合伙人UID" clearable size="mini" />
            </div>
          </div>
          <div class="item">
            <div class="ipt">
              <el-input v-model="userId" placeholder="用户UID" clearable size="mini" />
            </div>
          </div>
          <div class="item">
            <div class="ipt">
              <el-select v-model="type" placeholder="合约类型" size="mini" style="width: 140px">
                <el-option :value="1" label="合约" />
                <el-option :value="2" label="现货" />
              </el-select>
            </div>
          </div>
          <div class="item">
            <div class="ipt">
              <el-date-picker v-model="dateRange" type="daterange" align="right" format="yyyy-MM-dd"
                value-format="yyyy-MM-dd" unlink-panels range-separator="-" start-placeholder="开始日期"
                end-placeholder="结束日期" size="mini" />
            </div>
          </div>
          <div class="item">
            <el-button size="mini" type="primary" @click="handleSearch">查询</el-button>
          </div>
          <div class="item" v-if="type === 2">
            <el-select v-model="coin" size="mini" :placeholder="spotText.coin" @change="handleSearch">
              <el-option v-for="item in coins" :key="item.coin" :label="item.coin" :value="item.coin" />
            </el-select>
          </div>
        </div>
      </div>
      <el-table :data="tableList" height="calc(100vh - 360px)" size="mini">
        <el-table-column prop="statDate" label="统计日期" min-width="120">
          <template slot-scope="scope">
            {{ formatStatDate(scope.row.statDate) }}
          </template>
        </el-table-column>
        <el-table-column prop="userId" label="用户 UID" min-width="110" />
        <el-table-column prop="userType" label="用户类型" min-width="110" />
        <el-table-column prop="rebateRate" label="返佣比例" min-width="100">
          <template slot-scope="scope">
            <template v-if="appliedType === 2">
              <el-tooltip v-if="scope.row.rateKind === 'MULTIPLE'" placement="top">
                <div slot="content"><div v-for="item in scope.row.rateIntervals || []" :key="item.id">{{ percent(item.rate) }} · {{ time(item.effective_at) }} — {{ item.effective_until ? time(item.effective_until) : '…' }}</div></div>
                <span>{{ spotText.multi }}</span>
              </el-tooltip>
              <span v-else>{{ scope.row.rebateRate == null ? '—' : scope.row.rebateRate + '%' }}</span>
            </template>
            <template v-else>{{ scope.row.rebateRate }}%</template>
          </template>
        </el-table-column>
        <el-table-column prop="totalFee" :label="appliedType === 2 ? spotText.total : '总手续费(USDT)'" min-width="160" />
        <el-table-column prop="deductFee" :label="'扣减手续费(' + amountCoin + ')'" min-width="120" />
        <el-table-column prop="experienceDeductFee" :label="'体验金抵扣手续费(' + amountCoin + ')'" min-width="160" />
        <el-table-column prop="feeCouponDeduct" :label="'手续费抵扣券抵扣金额(' + amountCoin + ')'" min-width="190" />
        <el-table-column prop="actualFee" :label="'实际手续费(' + amountCoin + ')'" min-width="120" />
        <el-table-column prop="deductRebate" :label="'扣减返佣(' + amountCoin + ')'" min-width="120" />
        <el-table-column prop="experienceDeductRebate" :label="'体验金抵扣返佣(' + amountCoin + ')'" min-width="160" />
        <el-table-column prop="feeCouponDeductRebate" :label="'手续费抵扣券抵扣返佣(' + amountCoin + ')'" min-width="190" />
        <el-table-column prop="actualRebate" :label="'实际返佣(' + amountCoin + ')'" min-width="150">
          <template slot-scope="s">{{ appliedType === 2 && s.row.actualRebate == null ? '—' : s.row.actualRebate }}</template>
        </el-table-column>
        <el-table-column v-if="appliedType === 2" prop="paidRebate" :label="spotText.paid + '(' + amountCoin + ')'" min-width="150" />
      </el-table>
      <div class="pag">
        <pagination :size="pagination.size" :total="totalCount" :page="pagination.page" @pageChanged="pageChanged" />
      </div>
    </el-card>
  </div>
</template>

<script>
import Pagination from "components/pagination";
import api from "../api";
import { PAGINATION } from "../constants";
import moment from "moment";
import BigNumber from 'bignumber.js';
import labels from '@/components/spot-rebate/pageLabels';
import { call } from '@/components/spot-rebate/api';

export default {
  name: "FundsRebateDetail",
  components: { Pagination },
  data() {
    return {
      channelUserId: "",
      userId: "",
      type: 1,
      coin: 'USDT', coins: [{ coin: 'USDT' }], appliedType: 1, amountCoin: 'USDT', requestId: 0,
      dateRange: [
        moment().subtract(7, "days").format("YYYY-MM-DD"),
        moment().format("YYYY-MM-DD"),
      ],
      tableList: [],
      totalCount: 0,
      pagination: { ...PAGINATION },
    };
  },
  computed: { spotText() { return labels } },
  beforeDestroy() { this.requestId++ },
  created() {
    call(true, '/metadata').then(meta => { if (meta && Array.isArray(meta.coins)) this.coins = meta.coins }).catch(() => {});
    // 如果是资金概览列表跳转过来的，带上 query 里的参数
    if (this.$route && this.$route.query) {
      this.type = Number(this.$route.query.type) === 2 ? 2 : 1;
      this.coin = this.$route.query.coin || 'USDT';
      if (this.$route.query.channelUserId) {
        this.channelUserId = this.$route.query.channelUserId;
      }
      // 尝试获取开始和结束时间，支持传单个 dateRange 或 startTime/endTime
      if (this.$route.query.dateRange) {
        try {
          // 支持传 ["2024-03-01","2024-03-15"] 或 "2024-03-01,2024-03-15"
          let range = this.$route.query.dateRange;
          if (typeof range === 'string') {
            // 尝试 parse json 或 split
            try {
              range = JSON.parse(range);
              if (!Array.isArray(range)) {
                range = String(range).split(',');
              }
            } catch (e) {
              range = String(range).split(',');
            }
          }
          if (Array.isArray(range) && range.length === 2) {
            this.dateRange = range;
          }
        } catch (e) {
          // ignore
        }
      } else {
        // 支持单独传 startTime 和 endTime
        if (this.$route.query.startTime && this.$route.query.endTime) {
          this.dateRange = [this.$route.query.startTime, this.$route.query.endTime];
        }
      }
      // 支持 userId 查询
      if (this.$route.query.userId) {
        this.userId = this.$route.query.userId;
      }
    }
    this.fetchList();
  },
  methods: {
    percent(value) { return new BigNumber(value).times(100).toFixed() + '%' },
    time(value) { return moment(Number(value)).utcOffset(480).format('YYYY-MM-DD HH:mm:ss') },
    formatStatDate(val) {
      if (val == null || val === "") return "";
      if (typeof val === "string") return val;
      if (Array.isArray(val) && val.length >= 3) {
        const [y, m, d] = val;
        return `${y}-${String(m).padStart(2, "0")}-${String(d).padStart(2, "0")}`;
      }
      return String(val);
    },
    buildQuery(extra = {}) {
      const page = extra.page != null ? extra.page : this.pagination.page;
      const size = extra.size != null ? extra.size : this.pagination.size;
      return {
        page,
        size,
        channelUserId: this.channelUserId || undefined,
        userId: this.userId || undefined,
        type: this.type != null ? this.type : 1,
        coin: this.type === 2 ? this.coin : undefined,
        startTime: this.dateRange && this.dateRange[0] ? this.dateRange[0] : "",
        endTime: this.dateRange && this.dateRange[1] ? this.dateRange[1] : "",
      };
    },
    fetchList(extra = {}) {
      const q = this.buildQuery(extra);
      const request = ++this.requestId;
      this.tableList = []; this.totalCount = 0; this.appliedType = q.type; this.amountCoin = q.type === 2 ? q.coin : 'USDT';
      this.pagination = { page: q.page, size: q.size };
      api.getChannelRebateDetail(q).then((res) => {
        if (request !== this.requestId) return;
        if (res.code === 0 && res.data) {
          const d = res.data;
          this.tableList = d.list || d.records || [];
          this.totalCount = d.totalCount != null ? d.totalCount : d.total || 0;
        } else {
          this.tableList = [];
          this.totalCount = 0;
        }
      }).catch(() => { if (request === this.requestId) { this.tableList = []; this.totalCount = 0; } });
    },
    handleSearch() {
      this.fetchList({ page: 1, size: this.pagination.size });
    },
    pageChanged(p) {
      this.fetchList({ page: p.page, size: p.size });
    },
  },
};
</script>

<style lang="less" src="../../../styles/button.less" scoped></style>
<style scoped>
.pag {
  display: flex;
  justify-content: flex-end;
  margin-top: 12px;
}

.page-actions .select {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.page-actions .item .ipt {
  min-width: 140px;
}
</style>
